function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 17 1 C 9.3 1 3 7.3 3 15 C 3 18.4 4.3 21.6 6.3 24 L 4 31 L 11.3 27.8 C 13 28.6 15 29 17 29 C 24.7 29 31 22.7 31 15 C 31 7.3 24.7 1 17 1 Z M 17 1 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 23.7 19.1 C 24 18.2 24 17.5 23.9 17.3 C 23.8 17.1 23.6 17.1 23.2 16.9 C 22.8 16.7 21 15.8 20.7 15.7 C 20.4 15.6 20 15.6 19.8 16 C 19.4 16.5 19.1 17 18.8 17.3 C 18.6 17.5 18.2 17.6 17.9 17.4 C 17.5 17.2 16.3 16.8 14.9 15.6 C 13.8 14.6 13.1 13.4 12.8 13 C 12.6 12.6 12.8 12.4 13 12.2 C 13.2 12 13.4 11.8 13.6 11.6 C 13.8 11.4 13.9 11.3 14 11 C 14.1 10.8 14 10.5 13.9 10.3 C 13.8 10.1 13.1 8.3 12.8 7.6 C 12.6 7 12.4 7 12 7 C 11.9 7 11.7 7 11.6 7 C 11.1 7 10.6 7.1 10.3 7.5 C 9.9 7.9 9 8.8 9 10.6 C 9 12.4 10.3 14.2 10.5 14.4 C 10.7 14.6 13.1 18.4 16.8 20 C 19.7 21.2 20.6 21.1 21.2 21 C 22.2 20.7 23.4 20 23.7 19.1 Z M 23.7 19.1 ",
    transform: "matrix(0.46875,0,0,0.46875,0.46875,0.46875)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.5bde263f8719f122a70675977620f355.svg";
export { ForwardRef as ReactComponent };